export default "__VITE_ASSET__IvkgfOoM__"